import React, {memo} from "react";
import {Button, Col, Modal, Row, Form} from "react-bootstrap";
import BaseModal from "../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import {
    actionRefreshModalAddAddress
} from "../../../../../redux/actions/modals/modalAddAddress";
import TitlesModals from "../TitlesModals";
import {
    actionModalChangeAddressChangeLoader,
    actionModalChangeAddressChangeShow
} from "../../../../../redux/actions/modals/modalChangeAddress";
import {BASE_URL, USERS_ADDRESS_GET, USERS_EDIT_ADDRESS_POST} from "../../../../../apis";
import axios from "axios";
import qs from "querystring";
import {toast} from "react-toastify";
import {actionGetAddressUser} from "../../../../../redux/actions/user/user";
import {
    actionChangeInputsModalEditAddress,
    handelCloseModalEditAddress
} from "../../../../../redux/actions/modals/address/modalEditAddress";
// import MapGoogleNew from "../../map/MapGoogleNew";
import LeafletMap from "../../map/LeafletMap";
import {FaPlus} from "react-icons/all";

const ModalEditAddress = () => {
    const dispatch = useDispatch();
    const {statusShow, loader,textAddress,lng, lat,id} = useSelector(state => state.modalEditAddress);
    const {token} = useSelector(state => state.user);

    const handleClose = () => {
        dispatch(handelCloseModalEditAddress());
    };
    const handelBackModalChangeAddress = () => {
        apiHandelGetAddress();
        handleClose();
        dispatch(actionModalChangeAddressChangeShow(true));
    };
    const handelChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(actionChangeInputsModalEditAddress(name, value));
    };



    const handelClickEditAddress = () => {
        if (lat !== 0 && lng !== 0 && textAddress !== '')
            axios({
                url: BASE_URL + USERS_EDIT_ADDRESS_POST,
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: qs.stringify({
                    address_num:id,
                    glat: lat, glng: lng, address: textAddress,
                })
            }).then(response => {
                if (response.data.status === 'ok') {
                    toast.success(`آدرس مورد نظر با موفقیت اضافه شد.`, {
                        position: toast.POSITION.BOTTOM_CENTER
                    });
                    handelBackModalChangeAddress();
                    dispatch(actionRefreshModalAddAddress());
                } else {
                    toast.error(`آدرس ثبت نشد لطفا مجددا تلاش کنید.`, {
                        position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            });
        else
            toast.error(`متن آدرس و انتخاب آدرس را تکمیل کنید`, {
                position: toast.POSITION.BOTTOM_CENTER
            });
    };

    const apiHandelGetAddress = () => {
        dispatch(actionModalChangeAddressChangeLoader(true));
        axios({
            method: 'get',
            url: BASE_URL + USERS_ADDRESS_GET,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            dispatch(actionModalChangeAddressChangeLoader(false));
            dispatch(actionGetAddressUser(response.data.address));
        });
    };
    return (
        <BaseModal title={'ویرایش آدرس'}
                   show={statusShow}
                   dialogClassName={''}
                   handleClose={handleClose}>
            <Modal.Body>
                <TitlesModals>
                    <FaPlus className={'mr-2'}/>
                    <span>افزودن آدرس</span>
                </TitlesModals>
                <div className={'p-2'}>
                    <Form.Group controlId="textarea-txt-address-modal-address">
                        <Form.Label>وارد کردن آدرس به صورت دستی : </Form.Label>
                        <Form.Control name={'textAddress'} value={textAddress} onChange={handelChangeInputs} as="textarea" rows="3"
                                      placeholder="لطفا آدرس دقیق خود را در اینجا تایپ کنید."/>
                    </Form.Group>
                    <div>
                        <span>لطفا آدرس را از روی نقشه مشخص کنید : </span>
                        <div className={'base-map-box-modal-add-address'}>
                            { /*<MapGoogleNew data={{type: 'EDIT'}}/> */ }
                            <LeafletMap data={{type: 'EDIT'}}/>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Row className={'w-100 m-0'}>
                    <Col>
                        <Button variant="success" className={'base-btn-green'} block onClick={handelClickEditAddress}>ویرایش</Button>
                    </Col>
                    <Col>
                        <Button variant="success" className={'base-btn-green-border'} block onClick={handelBackModalChangeAddress}
                                disabled={loader}>
                            <span>بازگشت</span>
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </BaseModal>
    );
};

export default memo(ModalEditAddress);
